import {ColorDot} from 'components/utils/ColorDot';
import './ReviewTypeDropdown.styl';
import React, {ReactElement} from 'react';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import SimpleDropdown, {SimpleDropdownOption} from 'charts/components/forms/SimpleDropdown';
import CoachingReviewType from 'records/CoachingReviewType';
import {List} from 'immutable';
import {Int} from '@store/@types/util';
import {ELLIPSIS_DELAY} from 'components/StatsPage2.utils';

interface ReviewTypeDropdownProps {
  value?: Int;
  coachingReviewTypes: List<CoachingReviewType>;
  onSelect: (s: SimpleDropdownOption) => void;
  placeholder?: string;
  width?: number;
  arrow?: (open: boolean, onShowDropdown: () => void) => ReactElement;
  dropdownHeight?: number;
  allowReset?: boolean;
}

const ReviewTypeDropdown: React.FC<ReviewTypeDropdownProps> = ({
  value,
  coachingReviewTypes: incomingReviewTypes,
  onSelect,
  placeholder,
  width,
  arrow,
  dropdownHeight,
  allowReset,
  ...props
}) => {
  const coachingReviewTypes = incomingReviewTypes.sort((a, b) => a.name.localeCompare(b.name));

  const coachingReviewTypeOptions = coachingReviewTypes && [
    ...(allowReset
      ? [
          {
            id: -1,
            name: (
              <div className="dropdown-item">
                <ColorDot color={'gray'} size={12} />
                All Meeting Types
              </div>
            ),
          },
        ]
      : []),
    ...coachingReviewTypes
      .map(type => ({
        id: type.id!,
        name: (
          <GenericTooltip hoverBehavior delay={ELLIPSIS_DELAY} positionTop tooltip={type.name}>
            <div className="dropdown-item">
              <ColorDot color={type.meetingCategory!.color} size={12} />
              <span className="type-name">{type.name}</span>
            </div>
          </GenericTooltip>
        ),
      }))
      .toList(),
  ];

  const dropdownValue =
    value !== null && value !== undefined
      ? coachingReviewTypeOptions.find(({id}) => id === value)
      : undefined;

  return (
    <div className="review-type-dropdown" {...props}>
      <SimpleDropdown
        value={dropdownValue}
        selections={coachingReviewTypeOptions}
        onSelect={onSelect}
        placeholder={placeholder}
        width={width}
        arrow={arrow}
        dropdownHeight={dropdownHeight}
      />
    </div>
  );
};

export default ReviewTypeDropdown;
